import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { GameChoice } from '../types/lotto';

export function useGameDisplayName() {
  const { t } = useTranslation();
  return useCallback(
    (game: GameChoice) => {
      if (game === 'us_powerball') return t('home.gameNamePowerball');
      if (game === 'us_megamillions') return t('home.gameNameMega');
      return t('home.gameNameKr');
    },
    [t],
  );
}
